import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PlatformDetectionService {
  private readonly MOBILE_BREAKPOINT = 991;

  detectPlatform(): string {
    if (typeof window === 'undefined') return 'WEB';
    return window.screen.width <= this.MOBILE_BREAKPOINT ? 'RESPONSIVE' : 'WEB';
  }
}